import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/services/data.service';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';

export interface tipoIniciativa{
  estatus_tipoIniciativa:boolean;
  id_tipoIniciativa:number;
  nombre_tipoIniciativa:string;
}


@Component({
  selector: 'app-dialog-cambio-tipo-iniciativa',
  templateUrl: './dialog-cambio-tipo-iniciativa.component.html',
  styleUrls: ['./dialog-cambio-tipo-iniciativa.component.css']
})
export class DialogCambioTipoIniciativaComponent implements OnInit {
  listaTipoIniciativa:tipoIniciativa[]=[];
  dataTipoIniciativa
  accionForm: FormGroup;
  constructor(
    public dataService: DataService,
    private _fb: FormBuilder,
    public dialogRefEliminar: MatDialogRef<ConfirmacionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.cargarTipoIniciativas();
    this.crearForm();
  }


  onNoClick(): void {
    this.dialogRefEliminar.close();
  }

  save(){
    var form =this.accionForm.getRawValue();
    var body ={
      "id_iniciativa":this.data['id_iniciativa'],
      "userlogin":""+this.data['userLogin'],
      "rolUserLogin":this.data['rolSeleccionado'],
      "id_tipoIniciativa":form['tipo'],
      "id_tipoIniciativaANT":this.data['id_tipoIniciativa']
    }
    this.dialogRefEliminar.close(body);
  }

  crearForm(){
    this.accionForm = this._fb.group({
      tipo: ['', [Validators.required]]
    })
  }


  cargarTipoIniciativas()
  {
    this.dataService.getListTipoIniciativas().subscribe(
      data => {
        this.dataTipoIniciativa = data['data'];
        //Enlace de proyectos
        if(this.data['rolSeleccionado']==1)
        {
          this.dataTipoIniciativa.forEach((element,index )=> {
            if(element['id_tipoIniciativa']==2 || element['id_tipoIniciativa']==3)
            {
              this.listaTipoIniciativa.push(element);
            }
          });
        }else{
          this.dataTipoIniciativa.forEach((element,index )=> {
            if(element['id_tipoIniciativa']==1)
            {
              this.listaTipoIniciativa.push(element);
            }
          });

        }

      },
      error => {
        console.error(error);       
      }
    );
  }

}
